exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0daa2e91]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.even[data-v-0daa2e91] {\n  background-color: #f2f2f2;\n}\n.odd[data-v-0daa2e91] {\n  background-color: #fff;\n}", ""]);

// exports
